import styled from "styled-components"
import media from "src/styles/media"
import ReactTypingEffect from "react-typing-effect"
import TransitionLink from "src/components/util/TransitionLink"
import { isBrowser } from "src/utils/isBrowser"

import BackgroundImage from "gatsby-background-image"

export const HomeBannerWrapper = styled.section`
  width: 100vw;
  height: 110vh;

  ${media.lessThan("md")`
        height: 90vh;
    `}
`

export const HomeBannerContent = styled(BackgroundImage)`
  padding-top: 30px;
  width: 100%;
  height: 100%;
  background-position: 0 0;
  background-size: cover;
`

export const HomeBannerCaption = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 83%;
  text-align: left;

  ${media.lessThan("md")`
        height: 84%;
        text-align: center;
    `}
`

export const HomeBannerCaptionTitle = styled.h1`
    font-size: 50px;
    font-weight: 300;
    text-shadow: 1px 1px 20px rgba(250, 250, 250, .12);
    color: #fff;

    ${media.lessThan("lg")`
        font-size: 54px;
    `}

    ${media.lessThan("md")`
        font-size: 30px;
    `}

    ${media.lessThan("sm")`
        font-size: 22px;
    `}

    span{
        font-weight: 600;
    }
`

export const HomeBannerCaptionTitleSub = styled(
  isBrowser() ? ReactTypingEffect : TransitionLink
)`
    font-weight: 600;
    display: block;
    font-size: 74px;
    color: var(--secondary);
    margin-top: -30px;
    font-weight: normal;
    text-shadow: 1px 1px 20px rgba(33, 222, 232, .2);

    ${media.lessThan("lg")`
        font-size: 60px;
    `}

    ${media.lessThan("md")`
        font-size: 45px;
        margin-top: -20px;
        `}
        
        ${media.lessThan("sm")`
            font-size: 40px;
            margin-top: -10px;
        `}
`

export const HomeBannerCaptionDivisor = styled.hr`
  display: block;
  width: 150px;
  height: 3px;
  background-color: var(--secondary);
  margin: -5px 0 0 0;
  border: none;

  ${media.lessThan("md")`
        margin: 0 auto;
    `}
`

export const HomeBannerCaptionButton = styled.div`
  ${media.lessThan("sm")`
        button{
            font-size: 15px;
            padding: 6px 30px;
            border-width: 0.7px;
        }
    `}
`

export const HomeBannerCaptionDesc = styled.p`
    font-weight: 300;
    font-size: 25px;
    max-width: 600px;
    margin-top: 20px;
    color: #fff;
    padding: 10px;

    ${media.lessThan("lg")`
        font-size: 22px;
        max-width: 510px;
    `}

    ${media.lessThan("md")`
        font-size: 18px;
        margin: 20px auto 15px auto;
        max-width: 345px;
    `}

    ${media.lessThan("sm")`
        font-size: 18px;
    `}
`
